<section class="container-style">
  <p-tabs value="0">
    <p-tablist class="sticky-tablist">
      <p-tab value="0"><i class="pi pi-desktop me-2"></i>Web</p-tab>
      @if (swAppMovil) {
      <p-tab value="1"><i class="pi pi-mobile me-2"></i>Móvil</p-tab>
      }
      <app-custom-button class="widthBtns" [label]="'Guardar'" [icon]="'pi pi-pen-to-square'" [severity]="'primary'"
        [variant]="undefined" [width]="'7rem'" (onClick)="savePermissions()">
      </app-custom-button>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <ng-container *ngTemplateOutlet="moduleList; context: { $implicit: webModules }"></ng-container>
      </p-tabpanel>
      @if (swAppMovil) {
      <p-tabpanel value="1">
        <ng-container *ngTemplateOutlet="moduleList; context: { $implicit: appModules }"></ng-container>
      </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
</section>

<ng-template #moduleList let-modules>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-1">
    <p-accordion>
      @for (module of modules; track module.moduleId) {
      <p-accordion-panel [value]="module.moduleId">
        <p-accordion-header>
          <div class="d-flex flex-column">
            <div class="header-card-module d-flex gap-2">
              <span class="header-card"> {{ module.name }}</span>
              <app-custom-tag [severity]="getTagModule(module)" [value]="getTagTextModule(module)"
                [visibleLabel]="false">
              </app-custom-tag>
            </div>
            <div class="subtitle-card">
              <span class="subtitle-card"> {{ module.windows.length }} ventana(s)</span>
            </div>
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <hr class="m-0">
          <div class="permission-module py-1 px-3">
            <p class="my-2">Permisos del módulo
            </p>
            <div class="d-flex gap-2">
              <app-custom-button [label]="'Restringido'" [icon]="'pi pi-lock'" [width]="'7rem'"
                [severity]="getSeverityModule(module, 'restrict')" [variant]="getVariantModule(module,'restrict')"
                (onClick)="restrictAll(module)"></app-custom-button>
              <app-custom-button [label]="'Modificación'" [icon]="'pi pi-pen-to-square'" [width]="'7rem'"
                [severity]="getSeverityModule(module, 'modify')" [variant]="getVariantModule(module, 'modify')"
                (onClick)="modifyAll(module)"></app-custom-button>
              <app-custom-button [label]="'Consulta'" [icon]="'pi pi-eye'" [width]="'7rem'"
                [severity]="getSeverityModule(module,'consult')" [variant]="getVariantModule(module,'consult')"
                (onClick)="consultAll(module)"></app-custom-button>
            </div>
          </div>
          <hr class="m-0">
          @for (window of module.windows; track window.windowId) {
          <div class="permission-window d-flex align-items-center justify-content-between gap-4 px-3 ">
            <div class="d-flex-1 ">
              <div class="d-flex align-items-center gap-2">
                <span class="dot dot-primary"></span>
                <span class="text-foreground font-medium truncate">{{ window.labelName }}</span>
              </div>
            </div>
            <div class="d-flex gap-2 my-2">
              <app-custom-button [label]="'Restringido'" [icon]="'pi pi-lock'" [width]="'7rem'"
                [severity]="getSeverityWindow(window, 'restrict')" [variant]="getVariantWindow(window,'restrict')"
                (onClick)="changeWindow(null,window.windowId)"></app-custom-button>

              <app-custom-button [label]="'Modificación'" [icon]="'pi pi-pen-to-square'" [width]="'7rem'"
                [variant]="getVariantWindow(window, 'modify')" [severity]="getSeverityWindow(window, 'modify')"
                (onClick)="changeWindow(true,window.windowId)"></app-custom-button>

              <app-custom-button [label]="'Consulta'" [icon]="'pi pi-eye'" [width]="'7rem'"
                [severity]="getSeverityWindow(window,'consult')" [variant]="getVariantWindow(window,'consult')"
                (onClick)="changeWindow(false,window.windowId)"></app-custom-button>
            </div>
          </div>
          <hr class="m-0">
          }
        </p-accordion-content>
      </p-accordion-panel>
      }
    </p-accordion>
  </div>
</ng-template>
